import styled, { css } from 'styled-components';

import { IHeadingProps } from './Heading.types';

const Heading = styled.h1<IHeadingProps & { as: string }>`
  ${({ level, gutter, theme, type, as }) => {
    const l: number = level || ['h1', 'h2', 'h3', 'h4', 'h5'].indexOf(type || as || 'h1') + 1;

    return css`
      ${l === 1 && theme.heading[1].normal}
      ${l === 2 && theme.heading[2].normal}
      ${l === 3 && theme.heading[3].normal}
      ${l === 4 && theme.heading[4].normal}
      ${l === 5 && theme.heading[5].normal}

      color: ${theme.text.onSurface.strong};

      ${gutter &&
      l === 1 &&
      css`
        margin-bottom: 56px;
      `}

      ${gutter &&
      (l === 2 || l === 3 || l === 4) &&
      css`
        margin-bottom: 24px;
      `}

      ${gutter &&
      l === 5 &&
      css`
        margin-bottom: 16px;
      `}
    `;
  }}
`;

export { Heading };
